export default function Game_Obstacles() {
  return (
    <div>
      <h1>Game_Obstacles Component</h1>
    </div>
  );
}
